module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/programs-checkout@2x-1cf362633ddde4fab11c690d0b78515d.jpg";